/**
 * --------------------------------------------------------------------------
 * Bootstrap Italia (https://italia.github.io/bootstrap-italia/)
 * Authors: https://github.com/italia/bootstrap-italia/blob/main/AUTHORS
 * Licensed under BSD-3-Clause license (https://github.com/italia/bootstrap-italia/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

// NOTE:bootstrap italia version variable, useful to check for the current version

const BOOTSTRAP_ITALIA_VERSION = '2.16.0'
export default BOOTSTRAP_ITALIA_VERSION
